import { useEffect } from 'react';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import CheckBox from '../../../UI/FormControls/CheckBox';
import MyButton from '../../../UI/myButton/MyButton';
import { useTranslation } from 'react-i18next';

const Zaglavlje = ({
  zaposleniData,
  filterValues,
  setFilterValues,
  handlePretrazi,
}) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (filterValues.svi) {
      setFilterValues((curr) => {
        return { ...curr, lista: zaposleniData };
      });
    } else if (
      !filterValues.svi &&
      filterValues.lista.length === zaposleniData.length
    ) {
      setFilterValues((curr) => {
        return { ...curr, lista: [] };
      });
    }
  }, [filterValues.svi]);
  useEffect(() => {
    if (filterValues.lista.length !== zaposleniData.length) {
      setFilterValues((curr) => {
        return { ...curr, svi: false };
      });
    }
  }, [filterValues.lista]);
  const handleChange = (item) => {
    if (typeof filterValues[item.target.name] === 'boolean') {
      setFilterValues((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFilterValues((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };
  const handleClickZaposleni = (e) => {
    setFilterValues((curr) => {
      return { ...curr, lista: e };
    });
  };
  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
      <AutocompleteMulti
        options={zaposleniData}
        value={filterValues.lista}
        textProperty="vrednost"
        onChange={handleClickZaposleni}
        text="Zaposleni"
        style={{ maxWidth: '500px' }}
      />
      <CheckBox
        style={{ height: '70px' }}
        label="Svi"
        handleChange={handleChange}
        checked={filterValues.svi}
        name="svi"
      />
      <MyButton
        onClick={handlePretrazi}
        label={t('search')}
        icon="fas fa-search"
      />
    </div>
  );
};

export default Zaglavlje;
